import { Box, Container } from "@mui/material";

import RegisterSuccessForm from "components/auth/RegisterSuccessForm";

const RegisterSuccess = () => {
  return (
    <Box width={1}>
      <Container>
        <Box pt={{ lg: 5, xs: 3 }} pb={{ lg: 7, xs: 4 }}>
          <RegisterSuccessForm />
        </Box>
      </Container>
    </Box>
  );
};

export default RegisterSuccess;
